export const FirebaseConfig = {
  apiKey: "AIzaSyBHbZguhf0KCWxWOo0-a4zergYC_VSh4kM",
  authDomain: "bps-staging-2021.firebaseapp.com",
  databaseURL: "https://bps-staging-2021.firebaseio.com",
  projectId: "bps-staging-2021",
  storageBucket: "bps-staging-2021.appspot.com",
  messagingSenderId: "523499635661",
  appId: "1:523499635661:web:fb26e9b4bcb9c1f38dfa84",
  measurementId: "G-04B30MX7NT"
};